/** Flèche vers le bas sur les boutons qui ouvrent un menu Actions. */
export function ActionChevron() {
  return (
    <svg className="fx-action-chev" width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M6 9.5 12 15.5 18 9.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
